import { useContext } from "react"
import { ServerRenderedProps } from "source/shared/contexts/ServerRenderedProps"

export default function usePaymentMethodsUrl() {
  const { features } = useContext(ServerRenderedProps)

  const useSavedPaymentMethods = features.use_saved_payment_methods

  return useSavedPaymentMethods
    ? "/me/profile/payment-methods"
    : "/giving/profile/payment-methods"
}
